export default "__VITE_ASSET__4d042f34__"